import { OrganizationUsers } from "@/pages/organisaties/contactpersonen/OrganizationUsers"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/contactpersonen/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function RouteComponent() {
  const { organizationId } = useParams({
    from: "/beheer/organisaties/$organizationId/contactpersonen/",
  })

  return <OrganizationUsers organizationId={organizationId} />
}
